import BusinessAccountSelection from '@/pages/BusinessAccountSelection'
import Dashboard from '@/pages/Dashboard.vue'
import Export from '@/pages/Export.vue'
import Details from '@/pages/Details.vue'

const routes = [
    {
        path: '/select-business',
        name: 'Select Business Account',
        component: BusinessAccountSelection,
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/export",
        name: "Export",
        component: Export,
    },
    {
        path: "/details/:id",
        name: "Details",
        component: Details,
    },
];

export default routes.map(route => {
    const meta = {
        public: false
    };
    return { ...route, meta };
});